import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Filter } from "~/features/filter";

import { documentsFilterFields } from "./fields";

const DocumentsFilter = () => {
  const { t } = useTranslation();

  const fields = useMemo(() => documentsFilterFields(t), [t]);

  return <Filter.Root fields={fields} alwaysShow columns={6} />;
};

export default DocumentsFilter;
